exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-container {\n  display: flex;\n  justify-content: center;\n}\n\n.login__st-logo {\n    margin: 90px auto 70px;\n}\n", ""]);

// exports
